import { render, staticRenderFns } from "./divideList.vue?vue&type=template&id=079c387e&scoped=true&"
import script from "./divideList.vue?vue&type=script&lang=js&"
export * from "./divideList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c387e",
  null
  
)

export default component.exports